var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var EditOrderBillingInfoModal = /** @class */ (function (_super) {
    __extends(EditOrderBillingInfoModal, _super);
    function EditOrderBillingInfoModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onEmailChange = function (event, data) {
            var str = data.value;
            _this.setState({
                billingEmail: str
            });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/billing-email", {
                billingEmail: _this.state.billingEmail
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            billingEmail: props.initialBillingEmail
        };
        return _this;
    }
    EditOrderBillingInfoModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: "/billingEmail", labelContent: "Billing email" },
                React.createElement(Input, { value: this.state.billingEmail, onChange: this.onEmailChange })),
            React.createElement(Button, { disabled: this.state.success, icon: 'save', label: 'Save', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return EditOrderBillingInfoModal;
}(React.PureComponent));
export default EditOrderBillingInfoModal;
//# sourceMappingURL=EditOrderBillingInfoModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EditOrderBillingInfoModal.js
// module id = 1258
// module chunks = 0